import { Link, useLocation, useNavigate } from "react-router-dom";
import { Plane, LayoutDashboard, Shield, LogOut, LogIn, FileText, Palette } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const navLink = (to, label) => (
    <Link
      to={to}
      className={`text-sm font-medium px-3 py-1.5 rounded-md transition-colors ${
        location.pathname === to ? "bg-slate-100 text-slate-900" : "text-slate-500 hover:text-slate-900 hover:bg-slate-50"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header data-testid="navbar" className="sticky top-0 z-20 bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center" data-testid="nav-brand">
          <img src="/pnr-decode-wordmark.png" alt="PNR Decode" className="h-11 w-auto object-contain" />
        </Link>

        <nav className="flex items-center gap-1">
          {navLink("/", "Convert")}
          {!user && navLink("/pricing", "Pricing")}
          {navLink("/developers", "API Docs")}
          {user && user !== null && (
            <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm font-medium px-3 py-1.5 rounded-md text-slate-500 hover:text-slate-900 hover:bg-slate-50 inline-flex items-center gap-1.5">
              <LayoutDashboard className="h-4 w-4" /> Dashboard
            </Link>
          )}
          {user && user !== null && (
            <Link to="/itineraries" data-testid="nav-itineraries" className="text-sm font-medium px-3 py-1.5 rounded-md text-slate-500 hover:text-slate-900 hover:bg-slate-50 inline-flex items-center gap-1.5">
              <FileText className="h-4 w-4" /> Itineraries
            </Link>
          )}
          {user && user !== null && (
            <Link to="/branding" data-testid="nav-branding" className="text-sm font-medium px-3 py-1.5 rounded-md text-slate-500 hover:text-slate-900 hover:bg-slate-50 inline-flex items-center gap-1.5">
              <Palette className="h-4 w-4" /> Branding
            </Link>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="text-sm font-medium px-3 py-1.5 rounded-md text-slate-500 hover:text-slate-900 hover:bg-slate-50 inline-flex items-center gap-1.5">
              <Shield className="h-4 w-4" /> Admin
            </Link>
          )}
          <div className="ml-2 flex items-center gap-2">
            {user ? (
              <>
                <span className="text-sm text-slate-500 hidden sm:inline" data-testid="nav-user-email">{user.email}</span>
                <Button
                  data-testid="logout-btn"
                  variant="outline"
                  size="sm"
                  className="border-slate-200 text-slate-600"
                  onClick={() => { logout(); navigate("/login"); }}
                >
                  <LogOut className="h-4 w-4 mr-1.5" /> Logout
                </Button>
              </>
            ) : (
              user === false && (
                <>
                  <Button data-testid="nav-login-btn" variant="ghost" size="sm" onClick={() => navigate("/login")} className="text-slate-600">
                    <LogIn className="h-4 w-4 mr-1.5" /> Login
                  </Button>
                  <Button data-testid="nav-signup-btn" size="sm" className="bg-blue-600 hover:bg-blue-700 text-white" onClick={() => navigate("/register")}>
                    Sign up
                  </Button>
                </>
              )
            )}
          </div>
        </nav>
      </div>
    </header>
  );
}
